<template>
    <div class="c-audio-box mt-1  mb-1">
        <div class="c-audio-box__content">
            <div v-if="!listenLoading" class="c-audio-custom" @click="listen">
                <div class="c-audio-custom__icon"><i class="icon12-play-primary"></i></div>
                <div class="c-audio-custom__time">00:00 / {{ duration | callDuration }}</div>
                <div class="c-audio-custom__bar"><span style="width: 0%;"></span></div>
            </div>
            <audio ref="player" controls :hidden="!listenLoading" controlsList="nodownload">
                   <source :src="recordingUrl" type="audio/mp3" />
                Your browser does not support the audio element.
            </audio>
        </div>
    </div>
</template>

<script>

    export default {
        props: ["id", "duration"],
        data() {
            return {
                recordingUrl: null,
                listenLoading: false,
                updateLoading: false
            };
        },
        methods: {
            download() {
                if (this.recordingUrl) {
                    window.open(this.recordingUrl, "_blank");
                } else {
                    this.$service.get(`/call/${this.id}/recording`).then(response => {
                        window.open(response.data.url, "_blank");
                    });
                }

            },
            listen() {
                this.updateLoading = true;
                this.$service.get(`/call/${this.id}/recording`).then(response => {
                    this.listenLoading = true;
                    this.recordingUrl = response.data.url;
                    this.$refs.player.load();
                    this.$refs.player.play();
                }).catch(error => {
                    if (error.response.data.msg) {
                        this.$swal({
                            text: error.response.data.msg,
                            icon: 'error'
                        });
                    }
                }).finally(() => {
                    this.updateLoading = false;
                });

            },
        },
        mounted() {
        }
    }
</script>